import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import { Button, Checkbox, ConfigProvider, Dropdown, Flex, Row, Space, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs"
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useCallback, useEffect, useMemo, useState } from "react";
import ExpenseCreateModal from "features/Expense/components/ExpenseCreateModal";
import { useForm } from "antd/es/form/Form";
import useExpenseMainComponent from "features/Expense/hook/useExpenseMainComponent";
import * as services from "../../../Expense/Service/expenseApi";
import { generateRandomString } from "utils/helper";

const PendingApprovalExpenseTable = ({
    modalFlag = true,
    isLoading = false,
    pagination = {},
    onEdit = () => { },
    onReturn = () => { },
    onApprove = () => { },
    onReject = () => { },
    onCancel = () => { },
    onStatus = () => { },
    onChange = () => { },
    dataSource = [],
    pageType = "",
    onApproveAll = () => { },
    onRejectAll = () => { },
    onView = () => { },
    txnExpenseById = {}
}) => {
    function minitag(status) {
        switch (status) {
            case "Approved":
                return (
                    <Tag color="success"  >{status}</Tag>
                )
            case "Cancelled":
                return (<Tag color="error" >{status}</Tag>)
            case "Rejected":
                return (<Tag color="error" >{status}</Tag>)
            case "คำขอถูกยกเลิก":
                return (<Tag color="error" >{status}</Tag>)
            case "อนุมัติ":
                return (<Tag color="success" >{status}</Tag>)
            case "อนุมัติคำขอ":
                return (<Tag color="success" >{status}</Tag>)
            case "ยกเลิกคำขอ":
                return (<Tag color="error" >{status}</Tag>)
            case "คำขอถูกปฎิเสธ":
                return (<Tag color="error" >{status}</Tag>)
            default:
                return (<Tag color="processing" >{status}</Tag>)
        }
    }
    const { t, i18n } = useTranslation();
    // const dataSource = useSelector((state) => state.requestApproval.pendingExpense)

    const columns = [
        {
            title: <div className="text-table">{t('reqid')}</div>,
            dataIndex: "sequence",
            key: "sequence",
            visible: true,
        },
        {
            title: <div className="text-table">{t('name-surname')}</div>,
            dataIndex: "employee",
            key: "employee",
            visible: true,
            render: (text, record) => {
                return i18n.language === 'en' ? record?.employee?.nameAndSurnameEn : record?.employee?.nameAndSurname
            }
        },
        {
            title: <div className="text-table">{t('welfare.label.name')}</div>,
            dataIndex: "welfareName",
            key: "welfareName",
            visible: true,
            render: (_, record) => {
                return i18n.language === 'en' ? record?.welfare?.welfareNameEn : record?.welfare?.welfareName
            },
        },
        {
            title: <div className="text-table">{t('welfare_list.Expense_type')}</div>,
            dataIndex: "expenseType",
            key: "expenseType",
            visible: true,
            render: (_, record) => {
                return i18n.language === 'en' ? record?.welfareSubCategoryType?.nameEn : record?.welfareSubCategoryType?.name
            }
        },
        {
            title: <div className="text-table">{t('expense.label.create-date')}</div>,
            visible: true,
            key: "createDate",
            index: "createDate",
            render: (_, record) => {
                return i18n.language == "en" ? dayjs(record?.createDate).format("DD/MM/YYYY") : dayjs(record?.createDate).format("DD/MM/BBBB")
            }
        },
        {
            title: <div className="text-table">{t('leave_type.label.start_date')}</div>,
            visible: true,
            key: "startDate",
            index: "startDate",
            render: (_, record) => {
                return i18n.language == "en" ? dayjs(record?.startDate).format("DD/MM/YYYY") : dayjs(record?.startDate).format("DD/MM/BBBB")
            }
        },
        {
            title: <div className="text-table">{t('leave_type.label.end_date')}</div>,
            visible: true,
            key: "endDate",
            index: "endDate",
            render: (_, record) => {
                return i18n.language == "en" ? dayjs(record?.endDate).format("DD/MM/YYYY") : dayjs(record?.endDate).format("DD/MM/BBBB")
            }
        },
        {
            title: <div className="text-table">{t('expense.header')}</div>,
            dataIndex: "totalExpense",
            key: "totalExpense",
            visible: true,
            render: (_, record) => {
                return record?.totalExpense ? get2DecimalPointsWithCommas(record?.totalExpense) : "-"
            },
            align: "right"
        },
        {
            title: <div className="text-table">{t('description.description')}</div>,
            dataIndex: "description",
            key: "description",
            visible: true,
        },
        {
            title: <div className="text-table">{t("workin_location.label.status")}</div>,
            dataIndex: "status",
            key: "status",
            align: "center",
            visible: true,
            render: (text, record) => {
                // return i18n.language === 'en' ? minitag(record?.approveStatusEn) : minitag(record?.approveStatus)
                let language = i18n.language == "en" ? "En" : ""
                return <StatusTag value={(record?.["approveStatus" + language])} />
            }
        },
        {
            title: "",
            key: "action",
            align: "center",
            visible: modalFlag,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: () => handleView(record),
                                    label: t("action.view"),
                                    icon: <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                                {
                                    key: "2",
                                    onClick: () => onApprove({
                                        ...record,
                                        table: "PendingApprovalExpenseTable"
                                    }),
                                    label: `${t("action.approve")}`,
                                    icon: (
                                        <CheckOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                        />
                                    ),
                                },
                                {
                                    key: "3",
                                    onClick: () => onReject({
                                        ...record,
                                        table: "PendingApprovalExpenseTable"
                                    }),
                                    label: `${t("action.reject")}`,
                                    icon: (
                                        <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        },
    ];

    const visibleColumns = columns.filter((col) => col.visible);

    const [form] = useForm();
    const { currentEmployee, currentCompany } = useSelector((state) => state.company);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const hasSelected = selectedRowKeys.length > 0;
    const [isViewExpenseForm, setViewExpenseForm] = useState(false);
    const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);
    const [currentExpenseWorkflow, setCurrentExpenseWorkflow] = useState([]);
    const [selectedExpenseRecord, setSelectedExpenseRecord] = useState(null);

    const { getEmployeeWelfareDropdown,
        getdropdownProjectByEmployeeId,
        getEmployee,
        getCommonTypeByCode } = useExpenseMainComponent();

    const { dropdownProjectByEmployeeId, EmployeeWelfareDropdown, CommonTypeByCode } = useSelector((state) => state.expense);

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const modifiedWelfareType = useMemo(() => {
        const modifiedOptions = EmployeeWelfareDropdown?.map((opt) => ({
            value: opt?.id,
            label: i18n.language === "en" ? opt?.welfareNameEn : opt?.welfareName,
            code: opt.subcategoryDetails?.code,
        }));
        return modifiedOptions;
    }, [EmployeeWelfareDropdown, i18n.language]);

    const modifiedCommonTypeByCode = useMemo(() => {
        const modifiedOptions = CommonTypeByCode?.map((opt) => ({
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
        }));
        return modifiedOptions;
    }, [CommonTypeByCode, i18n.language]);

    const getExpenseWorkflow = useCallback(async (record) => {
        let data = [];

        data = await services.getWorkflowByRequestId({
            requestId: generateRandomString(),
            companyId: currentCompany,
            employeeId: currentEmployee,
            flowRequestId: record?.requestId,
        });
        setCurrentExpenseWorkflow(data?.data?.approvalSequence)

    }, [currentCompany, currentEmployee]);

    const handleView = (record) => {
        setSelectedExpenseRecord(record);
        setViewExpenseForm(true);
        setIsExpenseModalOpen(true);
        onView(record);
        getExpenseWorkflow(record);
    };

    useEffect(() => {
        if (isExpenseModalOpen) {
            getEmployeeWelfareDropdown();
            getdropdownProjectByEmployeeId();
            getEmployee({ employeeId: currentEmployee, visible: false, edit: false });
            getCommonTypeByCode();
        }
    }, [currentEmployee, getCommonTypeByCode, getEmployee, getEmployeeWelfareDropdown, getdropdownProjectByEmployeeId, isExpenseModalOpen])

    return (
        <Flex vertical gap={16}>
            <ExpenseCreateModal
                form={form}
                isViewExpenseForm={isViewExpenseForm}
                isExpenseModalOpen={isExpenseModalOpen}
                setIsExpenseModalOpen={setIsExpenseModalOpen}
                EmployeeWelfareDropdown={modifiedWelfareType}
                dropdownProjectByEmployeeId={dropdownProjectByEmployeeId}
                CommonTypeByCode={modifiedCommonTypeByCode}
                currentExpenseWorkflow={currentExpenseWorkflow}
                txnExpenseById={txnExpenseById}
                isApprove={true}
                onApprove={onApprove}
                onReject={onReject}
                selectedExpenseRecord={selectedExpenseRecord}
            />

            <ConfigProvider
                theme={{
                    components: {
                        Table: {
                            selectionColumnWidth: "45px"
                        },
                    },
                }}
            >
                <TableAntd
                    loading={isLoading}
                    style={{ backgroundColor: "white", width: "100%" }}
                    pagination={{
                        ...pagination,
                        showTotal: (total, range) =>
                            t("paginate.description")
                                .replace("{min}", range[0])
                                .replace("{max}", range[1])
                                .replace("{total}", total),
                    }}
                    dataSource={dataSource}
                    rowKey={(record) => record?.txnExpenseApproveId}
                    columns={visibleColumns}
                    onChange={onChange}
                    rowSelection={pageType === "view" ? rowSelection : undefined}
                />
            </ConfigProvider>

            {hasSelected && pageType === "view" &&
                (<Flex vertical gap={8} style={{ alignItems: "end" }}>
                    <span>{`${t("common.selected")} ${selectedRowKeys.length} ${t("common.items")}`}</span>
                    <Row style={{ gap: "8px" }}>
                        <Button
                            type="default"
                            style={{ borderRadius: "8px", height: "40px" }}
                            onClick={() => {
                                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item?.txnExpenseApproveId));
                                onRejectAll(selectedRecords).then(() => {
                                    setSelectedRowKeys([]);
                                });
                            }}
                        >
                            {t("request_approval.label.not_approved")}</Button>
                        <Button
                            type="primary"
                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
                            onClick={() => {
                                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item?.txnExpenseApproveId));
                                onApproveAll(selectedRecords).then(() => {
                                    setSelectedRowKeys([]);
                                });
                            }}
                        >{t("request_approval.label.approve")}</Button>
                    </Row>
                </Flex>)}
        </Flex>
    );
};

export default PendingApprovalExpenseTable;
